export const drawerWidth = 260;
export const drawerClosedWidth = 50;
export const addEditDrawerWidth  = 350;

export const actionColumns = ['actions'];
export const pageSizes = [10, 20, 50];
export const filteringStateColumnExtensions = [
  { columnName: 'actions', filteringEnabled: false },
];

export const stockAvailability = { 'available': 'AVAILABLE', 'unavailable': 'UNAVAILABLE'};
export const transportOrderState = { 'moving': 'MOVING', 'done': 'DONE', 'stopped': 'STOPPED'};

//number of colums on the orders overview page => 12/12 => 1 colum , 6/12 => 2, 4/12 => 3 , 3/12 => 4, ...
export const xsValue = 12 // 1 colum

// factor = 1 => tolerance compared with 100% of the measurement
// factor = 2 => tolerance compared with 50% of the measurement
// factor = 5 => tolerance compared with 20% of the measurement, .....
export const orderArticleWeightToleranceFactor = 5
export const orderArticleLengthToleranceFactor = 5
export const orderArticleWidthToleranceFactor = 5
export const orderArticleThicknessToleranceFactor = 5

//Machine parameters
export const machineParameterNames = {'vacuümpomp':'Kaliber Vacuümpomp', 'opening': 'Opening','temperatuur': 'Temperatuur','luchtblazer': 'Luchtblazer', 'oventemperatuur': 'Oven temperatuur', 'coronaKw': 'Corona Kw','trekrollendruk':'Trekrollen druk','output':'Output','treksnelheid':'Treksnelheid','pomptoerental':'Pomptoerental','matrijstemperatuurzones':'Matrijs temperatuurzones'}

//Machine Types
export const machine = 1;
export const machineScissor = 2;
export const machineScissorZone = 3;

//MachineIds
export const Line11 = 1;
export const Line12 = 2;
export const UpperScissorLine11 = 3;
export const LowerScissorLine11 = 4;
export const UpperScissorLine12 = 5;
export const LowerScissorLine12 = 6;

export const machineStatuses = {'PRODUCTION':'Production', 'SCRAP': 'Scrap','UNPLANNEDSTOP': 'Unplanned Stop','PLANNEDSTOP': 'Planned Stop'}

//Default login authentication error message
export const defaultAuthenticationErrorMessage = "The username and password do not match"

export const loginUserName = "demo"
export const loginPassWord = "demo"

//Material parameters
export const uomKg = "Kg";
export const uomPieces = "Stuks";
export const uomM = "M";
export const uomMm = "MM";
export const carrierTypePallet = 2;

//Product type
export const productTypePackaging = 'Packaging'
export const productTypeAdditive = 'Additive'
export const productTypeRawMaterial = 'RawMaterial'
export const productTypeTapeFoil = 'TapeFoil'
export const productTypeUnKnown = 'UnKnown'

//BOL namen
export const oprolsysteem = "OPROLSYSTEEM"
export const bedrukken = "P1BEDRUKKEN"
export const coronabehandeling = "P1CORONABEHANDELING"
export const microperforatie = "P1MICROPERFORATIE"
export const rillijnen = "P1RILLIJNEN"
export const snijlijnen = "P1SNIJLIJNEN"

// DataTypes
export const bool = 1;
export const integer = 2;
export const decimal = 3;
export const string = 4;

// Machine reasons
export const UnKnown = 0;
export const EndOfOrder = 1;
export const Cleaning = 2;
export const Rupture = 3;

// Planning view types
export const day = 0;
export const week = 1;
export const month = 2;

// Notification types
export const MachinePlannedStop = 1;
export const MachineUnPlannedStop = 2;
export const MachineStart = 3;
export const QualityOutOfSpec = 4;
export const ScissorScrap = 5;
export const ScissorProduction = 6;
export const UnKnownQualityCheckType = 7;

// Dimension quality checks
export const dimensionQualityChecks = {'LENGTEL':'Lengte L', 'LENGTER': 'Lengte R','BREEDTE': 'Breedte','DIKTE': 'Dikte', 'GEWICHT': 'Gewicht'}

//Progress timeStep
export const progressTimeStep = 1 // => 1 hour
